// All comments in English only
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";


interface Props {
    company: string;
    asOf?: string;
    riskScore: number;
    riskLevel: string;
    churnProb: number; // 0..1
    renewalDue: number; // 0..1
    renewed: number; // 0..1
    expired: number; // 0..1
    topProducts?: { product: string; risk_score_final: number; risk_level: string; behavior_label?: string | null }[];
}


export default function CustomerSummaryCard(props: Props) {
    const pct = (v: number | undefined) => (v == null ? "-" : `${Math.round(v * 100)}%`);
    const score = (v: number | undefined | null) => (v == null ? "-" : v.toFixed(1));
    return (
        <Card className="w-full">
            <CardHeader>
                <CardTitle className="flex items-center justify-between">
                    <span className="text-xl">{props.company}</span>
                    <span className="text-sm text-muted-foreground">As of {props.asOf}</span>
                </CardTitle>
            </CardHeader>
            <CardContent className="grid gap-4 md:grid-cols-4">
                <div className="rounded-2xl p-4 bg-muted">
                    <div className="text-sm text-muted-foreground">Risk Score</div>
                    <div className="text-2xl font-semibold">{score(props.riskScore)}</div>
                    <div className="text-xs mt-1">Level: {props.riskLevel}</div>
                </div>
                <div className="rounded-2xl p-4 bg-muted">
                    <div className="text-sm text-muted-foreground">Churn Probability</div>
                    <div className="text-2xl font-semibold">{pct(props.churnProb)}</div>
                </div>
                <div className="rounded-2xl p-4 bg-muted">
                    <div className="text-sm text-muted-foreground">Renewal Due</div>
                    <div className="text-2xl font-semibold">{pct(props.renewalDue)}</div>
                    <div className="text-xs mt-1">Renewed: {pct(props.renewed)} • Expired: {pct(props.expired)}</div>
                </div>
                <div className="rounded-2xl p-4 bg-muted">
                    <div className="text-sm text-muted-foreground mb-2">Top Risk Products</div>
                    <div className="space-y-1">
                        {props.topProducts?.slice(0, 5).map((p) => (
                            <div key={p.product} className="flex items-center justify-between text-sm">
                                <span>{p.product}</span>
                                <span className="text-muted-foreground">{p.risk_level} · {score(p.risk_score_final)}</span>
                            </div>
                        )) || <div className="text-sm text-muted-foreground">-</div>}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
